import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

class RebbellaRecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded === 'true') return;
    this.dataset.loaded = 'true';

    const viewedProducts = this.#orderedProductIds();
    if (viewedProducts.length === 0) return;

    const load = () => this.#loadProducts(viewedProducts);

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(load, { timeout: 1200 });
    } else {
      window.setTimeout(load, 150);
    }
  }

  #orderedProductIds() {
    return [...new Set(RecentlyViewed.getProducts().filter(Boolean))].slice(0, 4);
  }

  async #loadProducts(viewedProducts) {
    const sectionId = this.dataset.sectionId;
    const content = this.querySelector('[data-recently-viewed-content]');
    const grid = this.querySelector('[data-recently-viewed-grid]');

    if (!sectionId || !content || !grid) return;

    const url = new URL(Theme.routes.search_url, window.location.origin);
    url.searchParams.set('q', viewedProducts.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');

    try {
      const markup = await sectionRenderer.getSectionHTML(sectionId, false, url);
      const doc = new DOMParser().parseFromString(markup, 'text/html');
      const freshGrid = doc.querySelector('[data-recently-viewed-grid]');
      if (!freshGrid) return;

      const cardsById = new Map(
        [...freshGrid.querySelectorAll('[data-recently-viewed-product-id]')].map((card) => [
          card.getAttribute('data-recently-viewed-product-id'),
          card,
        ])
      );

      const orderedCards = viewedProducts.map((id) => cardsById.get(id)).filter(Boolean);
      if (orderedCards.length === 0) return;

      grid.replaceChildren(...orderedCards);
      content.hidden = false;
      this.removeAttribute('hidden');
    } catch (error) {
      console.warn('Recently viewed products could not be loaded.', error);
    }
  }
}

if (!customElements.get('rebbella-recently-viewed-products')) {
  customElements.define('rebbella-recently-viewed-products', RebbellaRecentlyViewedProducts);
}
